<template>
  <div>
    <!-- <h4 class="mt-5">isStatusSearchVehicle</h4> -->
    <!-- DriverPersonalDocument -->
    <b-form-group
      :label="$t('tracking.cargo.driverPersonalDocument')"
      label-for="DriverPersonalDocument"
    >
      <b-form-input
        id="DriverPersonalDocument"
        type="text"
        :placeholder="$t('tracking.cargo.driverPersonalDocument')"
        v-model="model.driverPersonalDocument"
        v-mask="'999.999.999-99'"
        @blur="getDriver"
        @keyup.enter="getDriver"
      />
      <span class="text-danger" v-if="modelstate['DriverPersonalDocument']">
        {{ modelstate["DriverPersonalDocument"][0] }}
      </span>
    </b-form-group>

    <!-- Driver -->
    <b-form-group :label="$t('tracking.cargo.driverName')" label-for="Driver">
      <b-form-input
        v-if="model.permissions == 1"
        id="Driver"
        type="text"
        :placeholder="$t('tracking.cargo.driverName')"
        v-model="model.driver"
        :readonly="driverVehicle"
      />
      <b-form-input
        v-if="model.permissions != 1"
        id="Driver"
        type="text"
        :placeholder="$t('tracking.cargo.driverName')"
        v-model="model.driver"
        :readonly="driverVehicle"
      />
      <span class="text-danger" v-if="modelstate['Driver']">
        {{ modelstate["Driver"][0] }}
      </span>
    </b-form-group>
    <!-- cellphone -->
    <b-form-group :label="$t('tracking.cargo.cellphone')" label-for="Cellphone">
      <b-form-input
        v-if="model.permissions == 1"
        id="Cellphone"
        type="text"
        :placeholder="$t('tracking.cargo.cellphone')"
        v-model="model.cellphone"
        :readonly="driverVehicle"
      />
      <b-form-input
        v-if="model.permissions != 1"
        id="Cellphone"
        type="text"
        :placeholder="$t('tracking.cargo.cellphone')"
        v-model="model.cellphone"
        :readonly="driverVehicle"
      />
      <span class="text-danger" v-if="modelstate['Cellphone']">
        {{ modelstate["Cellphone"][0] }}
      </span>
    </b-form-group>

    <!-- VehiclePlate -->
    <b-form-group label="Placa veículo" label-for="VehiclePlate">
      <b-form-input
        v-if="model.permissions == 1"
        id="VehiclePlate"
        type="text"
        placeholder="Placa veículo"
        v-model="model.vehiclePlate"
        :readonly="driverVehicle"
      />
      <b-form-input
        v-if="model.permissions != 1"
        id="VehiclePlate"
        type="text"
        placeholder="Placa veículo"
        v-model="model.vehiclePlate"
        :readonly="driverVehicle"
      />
      <span class="text-danger" v-if="modelstate['VehiclePlate']">
        {{ modelstate["VehiclePlate"][0] }}
      </span>
    </b-form-group>
    <!-- trailerPlate1 -->
    <b-form-group
      :label="$t('tracking.cargo.trailerPlate1')"
      label-for="TrailerPlate1"
    >
      <b-form-input
        v-if="model.permissions == 1"
        id="trailerPlate1"
        type="text"
        :placeholder="$t('tracking.cargo.trailerPlate1')"
        v-model="model.trailerPlate1"
        :readonly="driverVehicle"
      />
      <b-form-input
        v-if="model.permissions != 1"
        id="trailerPlate1"
        type="text"
        :placeholder="$t('tracking.cargo.trailerPlate1')"
        v-model="model.trailerPlate1"
        :readonly="driverVehicle"
      />
      <span class="text-danger" v-if="modelstate['TrailerPlate1']">
        {{ modelstate["TrailerPlate1"][0] }}
      </span>
    </b-form-group>
    <!-- trailerPlate2 -->
    <b-form-group
      :label="$t('tracking.cargo.trailerPlate2')"
      label-for="TrailerPlate2"
    >
      <b-form-input
        v-if="model.permissions == 1"
        id="trailerPlate2"
        type="text"
        :placeholder="$t('tracking.cargo.trailerPlate2')"
        v-model="model.trailerPlate2"
        :readonly="driverVehicle"
      />
      <b-form-input
        v-if="model.permissions != 1"
        id="trailerPlate2"
        type="text"
        :placeholder="$t('tracking.cargo.trailerPlate2')"
        v-model="model.trailerPlate2"
        :readonly="driverVehicle"
      />
      <span class="text-danger" v-if="modelstate['TrailerPlate2']">
        {{ modelstate["TrailerPlate2"][0] }}
      </span>
    </b-form-group>
    <!-- trailerPlate3 -->
    <b-form-group
      :label="$t('tracking.cargo.trailerPlate3')"
      label-for="TrailerPlate3"
    >
      <b-form-input
        v-if="model.permissions == 1"
        id="trailerPlate3"
        type="text"
        :placeholder="$t('tracking.cargo.trailerPlate3')"
        v-model="model.trailerPlate3"
        :readonly="driverVehicle"
      />
      <b-form-input
        v-if="model.permissions != 1"
        id="trailerPlate3"
        type="text"
        :placeholder="$t('tracking.cargo.trailerPlate3')"
        v-model="model.trailerPlate3"
        :readonly="driverVehicle"
      />
      <span class="text-danger" v-if="modelstate['TrailerPlate3']">
        {{ modelstate["TrailerPlate3"][0] }}
      </span>
    </b-form-group>

    <!-- driverShippingValue -->
    <b-form-group
      :label="$t('tracking.cargo.driverShippingValue')"
      label-for="DriverShippingValue"
    >
      <base-input-numeric
        id="driverShippingValue"
        :placeholder="$t('tracking.cargo.driverShippingValue')"
        :readonly="readonly"
        :value.sync="model.driverShippingValue"
      >
      </base-input-numeric>
      <span class="text-danger" v-if="modelstate['DriverShippingValue']">
        {{ modelstate["DriverShippingValue"][0] }}
      </span>
    </b-form-group>

    <!-- driverTollValue -->
    <b-form-group
      :label="$t('tracking.cargo.driverTollValue')"
      label-for="DriverTollValue"
    >
      <base-input-numeric
        id="driverTollValue"
        :placeholder="$t('tracking.cargo.driverTollValue')"
        :readonly="readonly"
        :value.sync="model.driverTollValue"
      >
      </base-input-numeric>
      <span class="text-danger" v-if="modelstate['DriverTollValue']">
        {{ modelstate["DriverTollValue"][0] }}
      </span>
    </b-form-group>

    <!-- DriverNegotiationType -->
    <b-form-group
      :label="$t('tracking.cargo.driverNegotiationType')"
      label-for="DriverNegotiationType"
    >
      <b-form-input
        id="driverNegotiationType"
        type="text"
        placeholder="Tipo de negociação motorista (Adiantamento / saldo)"
        v-model="model.driverNegotiationType"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['DriverNegotiationType']">
        {{ modelstate["DriverNegotiationType"][0] }}
      </span>
    </b-form-group>
    <!-- {{model}} -->
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import BaseInputNumeric from "@/components_rms/base/BaseInputNumeric.vue";
import BaseRowDetail from "@/components_rms/base/BaseRowDetail.vue";

export default {
  name: "CargoCrudData",
  components: {
    BaseInputNumeric,
  },
  directives: {
    mask: AwesomeMask,
    BaseRowDetail,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
  data: function () {
    return {
      driverIntegrated: false,
      driverIntegrationIsLoaded: false,
      driverOld: "",
      driverVehicle: true,
    };
  },
  created() {
    this.checkCompanyIntegration();
    this.driverOld = "";
    if(this.readonly)
      driverVehicle = this.readonly;
  },
  methods: {
    async checkCompanyIntegration() {
      this.driverIntegrated = true;
      this.driverIntegrationIsLoaded = false;

      this.$apiChecklist
        .get(`/systemIntegrationCompany/check/1`) // GWIntegration
        .then((response) => {
          if (response.data.success == true) {
            this.driverIntegrated = true;
          } else {
            this.driverIntegrated = false;
          }
          this.driverIntegrationIsLoaded = true;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log(error);
          console.log(error.message);
          if (error.response) {
            console.log(error.response);
            if (error.response.status == 401) {
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
              return;
            }
          }
          this.driverIntegrated = false;
          this.driverIntegrationIsLoaded = true;
          this.$forceUpdate();
        });
    },
    getDriver(e) {
      if (this.driverIntegrationIsLoaded == false) return;
      if (this.driverIntegrated == false) return;
      if (this.model.driverPersonalDocument == this.driverOld) return;

      this.driverOld = this.model.driverPersonalDocument;
      this.modelstate = {};
      this.model.driver = "";
      this.model.cellphone = "";
      this.model.vehiclePlate = "";
      this.model.trailerPlate1 = "";
      this.model.trailerPlate2 = "";
      this.model.trailerPlate3 = "";

      if (this.model.driverPersonalDocument == "") return;

      this.$api
        .get(`/v1/cargo/driver/document/${this.model.driverPersonalDocument}`)
        .then((response) => {
          // console.log(response.data);
          let cargoDriver = response.data;
          this.model.driver = cargoDriver.name;
          this.model.vehiclePlate = cargoDriver.plateMain;
          this.model.cellphone = cargoDriver.cellphone;
          this.model.trailerPlate1 = cargoDriver.plateTruckTrailer1;
          this.model.trailerPlate2 = cargoDriver.plateTruckTrailer2;
          this.model.trailerPlate3 = cargoDriver.plateTruckTrailer3;
          this.driverVehicle = true;
          // this.driverIntegrated = true;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log(error);
          console.log(error.message);
          if (error.response) {
            console.log(error.response);
            if (error.response.status == 401) {
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
              return;
            } else if (error.response.status == 404) {
              this.modelstate = {
                DriverPersonalDocument: [
                  `${this.$t("tracking.driver.documentNotFound")}: ${
                    this.model.driverPersonalDocument
                  }`,
                ],
              };
              return;
            } else {
              this.modelstate = {
                DriverPersonalDocument: [error.message],
              };
              return;
            }
          }
          // this.alert.error = error.message;
          // this.$refs.danger.show();
        });
    },
  },
  // watch:{
  //   driverOld(){
  //     console.log("entrou Model")
  //     if(this.model.driverPersonalDocument != null)
  //       this.driverVehicle = true;
  //   }
  // }
};
</script>
